import { createFileRoute, Outlet, useMatchRoute } from '@tanstack/react-router';
import { useAdminCheck } from '@/hooks/admin/useAdminCheck';
import { ApiHttpError } from '@/lib/apiHttpError';
import Unauthorized from '@/components/admin/Unauthorized';
import { SplashScreen } from '@/components/SplashScreen';
import AdminLayout from '@/components/admin/AdminLayout';

export const Route = createFileRoute('/_protected/admin')({
  component: AdminRootLayout,
});

function AdminRootLayout() {
  const adminCheck = useAdminCheck();
  const matchRoute = useMatchRoute();

  // Check if we're on the configure-programs route (which should NOT have AdminLayout)
  const isConfigureProgramsRoute = matchRoute({
    to: '/admin/users/$userId/configure-programs',
    fuzzy: true,
  });

  if (adminCheck.isError) {
    // Only check 403 (Forbidden) - user is authenticated but not an admin
    // 401 (Unauthorized) shouldn't happen here as parent _protected route handles authentication
    if (adminCheck.error instanceof ApiHttpError && adminCheck.error.response.status === 403) {
      return <Unauthorized />;
    }
    // Re-throw other errors (including 401) to be handled by error boundary
    throw adminCheck.error;
  }

  if (!adminCheck.isSuccess) {
    return <SplashScreen />;
  }

  // ConfigureProgramsForUser needs full-screen layout without AdminLayout
  if (isConfigureProgramsRoute) {
    return <Outlet />;
  }

  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
}
